import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M26.92 21.62c-.05-.12-.12-.23-.22-.33l-4-4a.996.996 0 1 0-1.41 1.41l2.29 2.29H6c-.55 0-1 .45-1 1s.45 1 1 1h17.59l-2.29 2.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l4-4a1 1 0 0 0 .22-1.09zM5.08 10.38c.05.12.12.23.22.33l4 4c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-2.29-2.29H26c.55 0 1-.45 1-1s-.45-1-1-1H8.41l2.29-2.29a.996.996 0 1 0-1.41-1.41l-4 4a1 1 0 0 0-.22 1.09z"
    />
  </svg>
);
const SvgIconArrowsLeftRight = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconArrowsLeftRight);
export default Memo;
